module.exports = __webpack_public_path__ + "img/01-menu-bar-off_01.a06c1fdc.png";